import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
// import { message } from 'antd'
// import FormComponent from './Form'
// import { client } from '@utils/client'
// import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'

import { wellKidzClubButton, wellKidzClubModal } from './List'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
import ErrorSvg from '@image/icons/ErrorSvg'
import { Button } from 'antd'
const Delete = (props) => {
  const { open, setOpen, onDelete } = props
  const { t } = useLocalization()
  const { theme } = useContext(ThemeContext)

  // const history = useHistory()
  // const params = useParams()

  // const handleSubmit = async (data) => {
  //   let id = data.id
  //   delete data.id // ลบ ID เนื่องจาก Put ใช้ส่งทั้ง Form Backend ไม่รับ
  //   data.url = data.url || null
  //   setOpen(false)
  //   try {
  //     await client.put(`/activity/${id}`, data)
  //     message.success('สำเร็จ')
  //     history.push('/activities')
  //   } catch (e) {
  //     message.error('ไม่สำเร็จ')
  //   }
  // }

  /**
   * @type {{
   * footer: React.CSSProperties,
   * body: React.CSSProperties,
   * btn: React.CSSProperties }}
   */

  const style = {
    body: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    footer: {
      display: 'flex',
      justifyContent: 'space-around',
      paddingTop: 24,
      gap: 8,
    },

    btn: {
      borderRadius: '8px',
      width: '170px',
      height: '40px',
      fontWeight: '600',
    },
  }
  return (
    <>
      <Modal
        centered={true}
        open={open}
        onCancel={() => setOpen(false)}
        closable={false}
        maskClosable={false}
        // footer={null}
        width={420}
        bodyStyle={{ padding: 40, overflowY: 'hidden', gap: 24 }}
      >
        <div style={style.body}>
          <ErrorSvg width={72} height={86} />
          <Text level={1} type="danger" strong>
            {t(`${wellKidzClubModal}.deleteCouponConfirm`)}
          </Text>
          <Text
            level={3}
            color={theme.text.black}
            style={{ textAlign: 'center', fontWeight: '600' }}
          >
            {t(`${wellKidzClubModal}.deleteCouponWarning`)}
          </Text>
        </div>
        <div style={style.footer}>
          <Button
            key="cancelSuspendWarning"
            onClick={() => setOpen(false)}
            style={style.btn}
          >
            <Text level={3} color={theme.text.darkGrey} semi>
              {t(`${wellKidzClubButton}.back`)}
            </Text>
          </Button>
          <Button
            type="primary"
            danger
            key="confirmSuspendWarning"
            onClick={() => onDelete()}
            style={style.btn}
          >
            <Text level={3} color={theme.text.white} semi>
              {t(`${wellKidzClubButton}.confirm`)}
            </Text>
          </Button>
        </div>
      </Modal>
    </>
  )
}

Delete.propTypes = {
  onDelete: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
}

export default Delete
